import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  DOCUMENT
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { FoldersService } from '../../../../state/folders.service';
import { IFolder } from '../../../../state/folders.repository';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
    selector: 'app-folder-editpage',
    templateUrl: './folder-editpage.component.html',
    styleUrls: ['./folder-editpage.component.scss'],
    standalone: false
})
export class FolderEditpageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private service: FoldersService) {}

  id!: string;
  folder: IFolder | null = null;

  ngOnInit(): void {
    this.route.paramMap.subscribe({
      next: (value) => {
        this.id = value.get('id')!;
        this.service.loadOneFolder(`${value.get('id')}`).subscribe((x) => {
          this.folder = x;
        });
      },
    });
  }
}
